import { render, staticRenderFns } from "./recibos.vue?vue&type=template&id=44a10334&scoped=true"
import script from "./recibos.vue?vue&type=script&lang=js"
export * from "./recibos.vue?vue&type=script&lang=js"
import style0 from "./recibos.vue?vue&type=style&index=0&id=44a10334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a10334",
  null
  
)

export default component.exports